import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import ScreenshotMonitorIcon from '@mui/icons-material/ScreenshotMonitor';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
//import CameraIcon from '@mui/icons-material/Camera';
import SecurityIcon from '@mui/icons-material/Security';

const services = [
  'Screen replacement and repair',
  'Battery replacement',
  'Camera repair and replacement',
  'Charging port repair',
  'Water damage treatment',
  'Speaker and microphone repair',
  'Button replacement',
  'Software issues and updates',
  'Data recovery and transfer',
  'Unlock services'
];

const benefits = [
  {
    icon: PhoneIphoneIcon,
    title: 'All Brands',
    description: 'Expert repair for all major smartphone and tablet brands'
  },
  {
    icon: SecurityIcon,
    title: 'Secure Service',
    description: 'Your data and privacy are protected throughout the repair'
  },
  {
    icon: ScreenshotMonitorIcon,
    title: 'Quality Parts',
    description: 'Only genuine replacement parts used for repairs'
  },
  {
    icon: BatteryChargingFullIcon,
    title: 'Quick Service',
    description: 'Most repairs completed within 24 hours'
  }
];

const deviceTypes = [
  {
    title: 'Smartphones',
    description: 'iPhone, Samsung, Google, OnePlus, and more'
  },
  {
    title: 'Tablets',
    description: 'iPad, Samsung Tab, Surface, and other tablets'
  },
  {
    title: 'Smart Watches',
    description: 'Apple Watch, Samsung Watch, and other brands'
  },
  {
    title: 'Other Devices',
    description: 'Gaming consoles, e-readers, and more'
  }
];

function MobileRepair() {
  return (
    <Box sx={{ py: 6, bgcolor: 'background.default' }}>
      {/* Hero Section */}
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            component="h1"
            className="gradient-text"
            sx={{ mb: 3 }}
          >
            Mobile Device Repair Services
          </Typography>
          <Typography
            variant="h5"
            sx={{ color: 'text.secondary', mb: 4 }}
          >
            Expert repair solutions for smartphones and tablets
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            size="large"
            sx={{
              py: 2,
              px: 4,
              fontSize: '1.2rem',
              background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
              '&:hover': {
                background: 'linear-gradient(45deg, #FF8E53 30%, #FE6B8B 90%)',
              }
            }}
          >
            Book Repair Now
          </Button>
        </Box>

        {/* Benefits Section */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card className="glass-effect card-hover">
                <CardContent sx={{ textAlign: 'center' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {React.createElement(benefit.icon, { sx: { fontSize: 40 } })}
                  </Box>
                  <Typography variant="h6" gutterBottom>
                    {benefit.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {benefit.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Services List */}
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            mb: 8,
            background: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)'
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
            Our Mobile Repair Services
          </Typography>
          <Grid container spacing={2}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={service} />
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Paper>

        {/* Device Types */}
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4,
            background: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)'
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
            Devices We Service
          </Typography>
          <Grid container spacing={3}>
            {deviceTypes.map((type, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card 
                  className="glass-effect"
                  sx={{ 
                    textAlign: 'center',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    p: 2
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    {type.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {type.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default MobileRepair;
